{
  "name": "mirror-hall",
  "doc": "A zoom whose centre is off-axis, right of the frame: the history slides toward one side and the MIRROR wave doubles it. Reads as a hall of mirrors receding to the right.",
  "cx": 0.72,
  "cy": 0.5,
  "zoom": 1.02,
  "zoomexp": 1.0,
  "rot": 0.0,
  "rotr": 0.0,
  "dx": 0,
  "dy": 0,
  "sx": 1,
  "sy": 1,
  "warp": 0,
  "warpScale": 4,
  "warpSpeed": 0.3,
  "decay": 0.96,
  "invert": 0,
  "hueShift": 0.003,
  "darkenCenter": 0.3,
  "wave": "MIRROR",
  "waveColor": 0,
  "shapes": 1,
  "energy": [
    0.3,
    0.75
  ]
}